// @flow
import LocalizationStore from './store/LocalizationStore';

export * from './service';

export const localizationService = new LocalizationStore();

export type * from './types';
